export const DEFAULT_LIMIT_DOCUMENTS = 30
export const DEFAULT_OFFSET_DOCUMENTS = 0
